import PropTypes from 'prop-types';

export default PropTypes.shape({
  /** Which step of wizard should be displayed. */
  activeStep: PropTypes.number,
  /** amount of power needed at direct HA */
  power: PropTypes.string,
  /** type of heating needed at direct HA */
  heatingType: PropTypes.shape({
    oil: PropTypes.bool,
    gas: PropTypes.bool,
    electro: PropTypes.bool,
  }),
  /** Number of rooms */
  rooms: PropTypes.string,
  /** Rooms total area */
  totalArea: PropTypes.string,
  /** Rooms average height */
  averageHeight: PropTypes.string,
  /** What level of isolation was selected. */
  isolation: PropTypes.number,
  /** Contact form gender. */
  gender: PropTypes.string,
  /** Contact form name. */
  name: PropTypes.string,
  /** Contact form surname. */
  surname: PropTypes.string,
  /** Contact form country code. */
  countryCode: PropTypes.string,
  /** Contact form phone. */
  phone: PropTypes.string,
  /** Contact form company. */
  company: PropTypes.string,
  /** Contact form email. */
  email: PropTypes.string,
  /** Contact form address. */
  deliveryAddress: PropTypes.shape({
    street: PropTypes.string,
    postalCode: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  }),
  /** Rental date from. */
  dateFrom: PropTypes.instanceOf(Date),
  /** Rental date to. */
  dateTo: PropTypes.instanceOf(Date),
  /** Indoor temperature. */
  indoorTemperature: PropTypes.number,
  /** Outdoor temperature. */
  outdoorTemperature: PropTypes.number,
  /** Type of HA user flow' */
  flow: PropTypes.oneOf(['direct', 'wizard']),
});
